import React, { Suspense } from 'react';
import { RowLayout, RowLoadingSkeleton } from './dashboardRow';
import VisitorsWidget from 'ui/_pages/home/components/VisitorsWidget/VisitorsWidget';
import BenefitsWidget from 'ui/_pages/home/components/BenefitsWidget/BenefitsWidget';
import DiscountsWidget from 'ui/_pages/home/components/DiscountsWidget/DiscountsWidget';

const WIDGET_PROPS = {
  title: 'Your Benefits & Visitors',
};

const BenefitsAndVisitorsCardList: React.FC = () => {
  return (
    <RowLayout {...WIDGET_PROPS}>
      <ul className="tw:grid tw:grid-cols-1 tw:lg:grid-cols-3 tw:gap-6 tw:pl-0">
        <li className="tw:list-none tw:w-full">
          <VisitorsWidget />
        </li>
        <li className="tw:list-none tw:w-full">
          <BenefitsWidget />
        </li>
        <li className="tw:list-none tw:w-full">
          <DiscountsWidget />
        </li>
      </ul>
    </RowLayout>
  );
};

const BenefitsAndVisitorsWidget: React.FC = () => (
  <Suspense fallback={<RowLoadingSkeleton {...WIDGET_PROPS} />}>
    <BenefitsAndVisitorsCardList />
  </Suspense>
);

export default BenefitsAndVisitorsWidget;
